<template>
  <b-container fluid id="app" class="vh-100 overflow-y p-0 bg-darkblue">
    <router-view />
  </b-container>
</template>

<script>
import { BContainer } from "bootstrap-vue";

export default {
  name: "App",
  components: { BContainer },
};
</script>

<style lang="scss">
@import "@/assets/scss/_anyvers.scss";
</style>
